import { getClientCatalogs } from "components/localOfferEligibility/LocalOfferEligibility";
import React, { useReducer } from "react";

export const FilterContext = React.createContext(null);

const EMPTY_STATE = { searchState: {}, filters: {} };

const reducer = (state, action) => {
  switch (action.type) {
    case "updateSearchState": {
      const newState = {
        ...state,
        searchState: {
          page: action.searchState.page || 1,
          refinementList: {
            ...state?.searchState.refinementList,
            ...action.searchState.refinementList,
          },
          range: {
            ...state?.searchState.range,
            ...action.searchState.range,
          },
          hierarchicalMenu: action.searchState.hierarchicalMenu,
          query: action.searchState.query,
        },
      };
      if (action.searchState.sortBy || state?.searchState.sortBy) {
        newState.searchState.sortBy = action.searchState.sortBy || state?.searchState.sortBy;
      }
      return newState;
    }
    case "resetFilters": {
      return {
        ...state,
        searchState: {
          refinementList: {
            "catalogs.slug": getClientCatalogs(true),
          },
          hierarchicalMenu: state.searchState.hierarchicalMenu,
        },
      };
    }
    default:
      return state;
  }
};

const persistor = (state, action) => {
  return reducer(state, action);
};

const FilterProvider = ({ children }) => {
  const reducer = useReducer(persistor, EMPTY_STATE);
  return <FilterContext.Provider value={reducer}>{children}</FilterContext.Provider>;
};

export default FilterProvider;
